'use strict';

var Util = require('./util/index');
var getCookie = require('./util/cookie');

module.exports = {
    getExt: function getExt() {
        var ret = {};
        try {
            var network = getCookie('network');
            if (!network) {
                var ua = Util.getUserAgent();
                var reg = /NetType\/([a-zA-Z0-9]+)/;
                if (ua && reg.test(ua)) {
                    network = ua.match(reg)[1];
                }
            }
            network = network || Util.getConnectionType();
            var unionId = getCookie('uuid') || getCookie('unionid') || getCookie('dpid') || getCookie('_lxsdk_cuid');
            if (network) ret.network = network;
            if (unionId) ret.unionId = unionId;
        } catch (e) {}
        return ret;
    }
};